import React from "react";
import Webcam from "react-webcam";

const WebcamCapture = (props) => {
  let { Bs, returnImg, hdr, changecam, } = props;
  const webcamRef = React.useRef(null);
  const iconRef = React.useRef(null);
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = React.useState(false);
  // eslint-disable-next-line no-unused-vars
  const [devices, setDevices] = React.useState([]);
  const [resolution, setResolution] = React.useState(
    JSON.parse(localStorage.getItem("webCam"))
      ? JSON.parse(localStorage.getItem("webCam"))
      : {
          height: 900,
          width: 1440,
          facingMode: "enviroment",
        }
  );

  const handleDevices = React.useCallback(
    (mediaDevices) =>
      setDevices(mediaDevices.filter(({ kind }) => kind === "videoinput")),
    [setDevices]
  );
    

  const FACING_MODE_USER = "user";
  const FACING_MODE_ENVIRONMENT = "environment";
  const [facingMode, setFacingMode] = React.useState(FACING_MODE_USER);
  const handleClick = React.useCallback(() => {
    setFacingMode((prevState) =>
      prevState === FACING_MODE_USER
        ? FACING_MODE_ENVIRONMENT
        : FACING_MODE_USER
    );
  }, []);

  React.useEffect(() => {
    setInterval(() =>{
      if (iconRef.current) {
        iconRef.current.focus();
      }
    },1000)
      
  }, []);

  const capture = React.useCallback(() => {
    setLoading(true);
    const imageSrc = webcamRef.current.getScreenshot();
    returnImg(imageSrc);
    setLoading(false);
  }, [webcamRef, returnImg]);

  React.useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then(handleDevices);
  }, [handleDevices]);

  let videoConstraints = {
    facingMode: facingMode,
    width: resolution.width,
    height: resolution.height,
  };
  return (
    <Bs row className="mt-4">
      <Bs col xs={12} className="webscan-div d-flex justify-content-between">
        {resolution.width < 2000 && hdr && (
          <props.Icon
            mdhdroffselect
            data-tip="Přepnout na focení zařízení"
            className="webcam-change-res-btn"
            onClick={() => {
              setResolution({
                height: 1600,
                width: 2560,
              });
              localStorage.setItem(
                "webCam",
                JSON.stringify({
                  height: 1600,
                  width: 2560,
                })
              );
            }}
          />
        )}
        {resolution.width >= 2000 && hdr && (
          <props.Icon
            mdhdronselect
            data-tip="Přepnout na focení dokumentu"
            className="webcam-change-res-btn"
            onClick={() => {
              setResolution({
                height: 900,
                width: 1440,
              });
              localStorage.setItem(
                "webCam",
                JSON.stringify({
                  height: 900,
                  width: 1440,
                })
              );
            }}
          />
        )}
        {changecam && (
          <props.Icon
            mdcameraswitch
            data-tip="Změnit kameru"
            className="webcam-switchcam-btn"
            onClick={handleClick}
          />
        )}
      </Bs>
      <Bs row>
        <Bs col xs={12}>
          <Webcam
            className="webcam-fullwidth"
            audio={false}
            ref={webcamRef}
            width={200}
            forceScreenshotSourceSize={true}
            screenshotQuality={1}
            videoConstraints={videoConstraints}
            screenshotFormat="image/jpeg"
          />
        </Bs>
      </Bs>
      <Bs row>
        <Bs
          col
          xs={12}
          className="webscan-div-capture d-flex justify-content-center"
        >
          <Bs
            button
            size="sm"
            variant="success"
            className="webcam-capture-btn"
            onClick={capture}
            ref={iconRef}
            autoFocus
            tabIndex={0}
            onKeyPress={(e) => {
              console.log(e);
              if (e.Key === "Enter") capture();
            }}
          >
            <props.Icon aifillcamera />
          </Bs>
        </Bs>
      </Bs>
    </Bs>
  );
};

export default WebcamCapture;
